import { Game } from '../game.model';

export class Started {
  game: Game;
}
